

exports.__esModule = true;
exports.$xoSidepageAddCardPageComponent = undefined;

var _angular = require('angular');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('components/xo-wallet-components/src/add-card/directive');

require('components/xo-page-components/src/aside-header/directive');

require('components/xo-validation/dist/directive');

require('components/xo-ui-components/src/tooltip/directive');

require('components/xo-ui-components/src/dropdown/directive');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidepageAddCardPageComponent = exports.$xoSidepageAddCardPageComponent = _squid.$Component.extend('$xoSidepageAddCardPageComponent', {
    tag: 'xo-sidepage-add-card-page',
    template: _template2['default'],

    scope: {
        token: '=',
        callbacks: '='
    },

    lifecycle: {
        enter: function enter() {
            var interval = (0, _angular.$interval)(function () {
                var el = (0, _jquery2['default'])('#sidepageAddCard');
                if (el) {
                    _angular.$interval.cancel(interval);
                    el.addClass('sidepageAddCardOpen');
                }
            }, 100);
        }
    },

    controller: function controller($scope, $rootScope, $stateParams) {
        $scope.billingaddressupdated = {
            value: false
        };
        $scope.isUpdateDebitCard = function () {
            return $stateParams.message === 'EXPIRED_DEBIT_CARD';
        };
        $scope.token = $rootScope.token;
        $scope.message = {};
    }
});

angular.value("$xoSidepageAddCardPageComponent", $xoSidepageAddCardPageComponent);
_angular.$interval;

_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidepage-add-card/directive.js
// module id = ./pages/xo-sidepage-add-card/directive.js
// module chunks = 1